export default {
  unavailable: {
    title: 'Questo servizio è gestito da Foodamigos',
    description:
      'La stampa di volantini e adesivi è un servizio gestito dal team Foodamigos e non è disponibile per gli account partner.',
  },
};
